import React from "react";
import styled from "styled-components";

import Link from "./Link";

const DisabledLink = styled.span`
  color: #999;
`;

export default ({ children, disabled, ...props }) =>
  !disabled ? (
    props.is_external_url ? (
      <a href={props.url} {...props} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    ) : (
      <Link {...props}>{children}</Link>
    )
  ) : (
    <DisabledLink {...props}>{children}</DisabledLink>
  );



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/Link/index.js